<template>
	<div class="list-container recommand">
		<div class="initial-loading-indicator-container" v-if="initialDataLoading">
			<div class="loader-indicator text-center my-3 text-xs py-1">
						<pulse-loader
							:loading="initialDataLoading"
							color="#cccccc"
							size="6px"
						></pulse-loader>
					</div>
		</div>
		<div class="top-content mb-8">
			<div class="top-videos mb-4" v-if="this.topLargeVideoListData?.length > 0">
				<ul>
					<div class="grid grid-cols-1 gap-4 gap-y-4 ">
						<template v-for="item in this.topLargeVideoListData" :key="item.id">
							<VideoItem
								:videoThumbnailURL="item.file.thumbnail"
								:imageURL="item.thumbnail.thumbnail"
								:title="item.title"
								:desc="item.abstract"
								:url="'/vlog/video/' + item.id"
								:date="item.display_date"
							></VideoItem>
						</template>
					</div>
				</ul>
			</div>

			<div class="top-other-videos" v-if="this.topContentListData?.length > 0">
				<ul>
					<div class="grid grid-cols-2 gap-4 gap-y-4 ">
						<template v-for="item in this.topContentListData" :key="item.id">
							<VideoItem
								:videoThumbnailURL="item.file.thumbnail"
								:imageURL="item.thumbnail.thumbnail"
								:title="item.title"
								:desc="item.abstract"
								:url="'/vlog/video/' + item.id"
								:date="item.display_date"
							></VideoItem>
						</template>
					</div>
				</ul>
			</div>
		</div>
		<div class="video-course section" v-if="this.videoCourseListData?.length > 0">
			<h2 class="section-title">最新视频课程</h2>
			<vue-horizontal class="scroller" :button="false">
				<div
					v-for="item in this.videoCourseListData"
					:key="item.id"
					class="top-course-item"
				>
					<VideoItem
						:imageURL="item.thumbnail.thumbnail"
						:title="item.title"
						:externalLink="item.show_url"
					></VideoItem>
				</div>
			</vue-horizontal>
		</div>

		<div class="list-content section" v-if="this.contentListData?.length > 0">
			
			<h2 class="section-title">更多推荐视频</h2>

			<ul>
				<div class="grid grid-cols-2 gap-4 gap-y-4 ">
					<template v-for="item in this.contentListData" :key="item.id">
						<VideoItem
							:videoThumbnailURL="item.file.thumbnail"
							:imageURL="item.thumbnail.thumbnail"
							:title="item.title"
							:desc="item.abstract"
							:url="'/vlog/video/' + item.id"
							:date="item.display_date"
						></VideoItem>
					</template>
				</div>
			</ul>
			<InfiniteLoading
				class="infinite-loader"
				@infinite="loadData"
				v-if="initialDataLoaded"
			>
				<template #complete>
					<div class="loader-indicator text-center my-3 text-xs text-gray-400">
						<!-- <span>加载完成</span> -->
					</div>
				</template>
				<template #error="{ retry }">
					<div class="loader-indicator text-center my-3 text-xs">
						<button @click="retry">重试</button>
					</div>
				</template>
				<template #spinner>
					<div class="loader-indicator text-center my-3 text-xs py-1">
						<pulse-loader
							loading="loading"
							color="#cccccc"
							size="6px"
						></pulse-loader>
					</div>
				</template>
			</InfiniteLoading>
		</div>
	</div>
</template>

<script>
import InfiniteLoading from "v3-infinite-loading";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import axios from "axios";
import VideoItem from "@/components/vlog/components/VideoItem.vue";
// import VideoItem from "@/components/vlog/components/VlogVideoItemSmall.vue";

import VueHorizontal from "vue-horizontal";

export default {
	name: "VlogRecommandList",
	props: {
		// 内容表、商品表
		contentType: {
			type: String,
			default: "content",
		},
	},
	components: {
		InfiniteLoading,
		PulseLoader,
		VideoItem,
		VueHorizontal,
	},
	data() {
		return {
			// 一行一列
			topLargeVideoListData: [],
			// 2-columns
			topContentListData: [],
			videoCourseListData: [],
			contentListData: [],
			nextPage: 1,
			isLoaded: false,
			initialDataLoading: false,
			initialDataLoaded: false,
			loadMessage: "",
		};
	},
	methods: {
		constructContentRequestParams() {
			return {
				mold_types: "2",
				is_not_show_description: 1,
				page_size: 40,
				page: this.nextPage,
				// 推荐优先、排序其次、发布时间再次
				order: '{"is_recommended":"desc","sort":"desc","published_at":"desc"}',
			};
		},
		loadData(state) {
			state.loading();
			const url = "/api/gatewayCms/articles/list";
			const that = this;
			// console.log('request: ' + JSON.stringify(this.constructRequestParams()));
			axios
				.get(url, {
					params: this.constructContentRequestParams(),
				})
				.then((response) => {
					// that.loading = false;
					const responseData = response.data;
					that.nextPage += 1;

					// console.log("before updates");

					// console.log(that.contentListData);

					if (responseData.data?.data?.length > 0) {
						that.contentListData.push(...responseData.data.data);
						// console.log(that.contentListData);

						state.loaded();
						// state.loading();
					} else {
						state.complete();
						// state.loading();
					}
				})
				.catch((error) => {
					// error;
					// that.loading = false;
					// console.log("state.error");

					// console.log(error);
					state.error(error);
				});
		},
		setupInitialData(contentData, courseData) {
			// console.log(contentData);
			// console.log(courseData);
			if (contentData?.length == 0 && courseData?.length == 0) {
				this.loadMessage = "还没有上传视频";
			} else {
				this.videoCourseListData = courseData;
				// console.log(courseData);

				var topContent = [];
				// console.log(contentData);
				if (contentData?.length > 5) {
					// 前五个暂存topContent
					topContent = contentData.slice(0, 5);
					// 五个以后切割
					this.contentListData = contentData.slice(5);
				} else {
					topContent = contentData;
					this.contentListData = [];
				}

				// 按奇偶处理topContent
				if (topContent.length > 1) {
					if (topContent.length % 2 == 0) {
						// 偶数,大图x2，其余小图
						this.topLargeVideoListData = topContent.slice(0, 2);
						this.topContentListData = topContent.slice(2);
					} else {
						// 奇数,大图x1，剩余小图
						this.topLargeVideoListData = topContent.slice(0, 1);
						this.topContentListData = topContent.slice(1);
					}
				} else {
					// 小于2,全部大图显示
					this.topLargeVideoListData = topContent;
					this.topContentListData = [];
				}
			}
			// console.log("---topLargeVideoListData")
			//       console.log(this.topLargeVideoListData);
			//       console.log("---topContentListData")

			//       console.log(this.topContentListData);
			//       console.log("---videoCourseListData")

			//       console.log(this.videoCourseListData);
		},
		requestInitialData() {

			this.initialDataLoading = true;

			const url = "/api/gatewayCms/articles/list";
			const videoCourseUrl = "/api/gatewayCms/shopGoods/list";
			const that = this;
			axios
				.all([
					axios.get(url, {
						params: this.constructContentRequestParams(),
					}),
					axios.get(videoCourseUrl, {
						params: {
							mold: "6",
							audit_status: 1,
							order: '{"sort":"desc","published_at":"desc"}',
						},
					}),
				])
				.then(
					axios.spread((...responses) => {
						// console.log(responses);
						let contentResponse = responses[0];
						let courseResponse = responses[1];

						let contentResponseData = contentResponse.data?.data?.data;
						let courseResponseData = courseResponse.data?.data?.data;
						// console.log(courseResponseData);
						that.setupInitialData(contentResponseData, courseResponseData);
						
						// next page.
						this.nextPage += 1;
						that.initialDataLoading = false;
						that.initialDataLoaded = true;
					})

					
				)
				.catch((errors) => {
					errors;
					that.initialDataLoading = false;
					that.initialDataLoaded = false;
					that.initialDataErrorMessage = "发生错误，请重试";
				});
		},
	},
	mounted() {
		// 1. 这个列表直接通过load-more组件进行加载即可
		// 1. request 推荐内容第一页
		// 1.1 request 视频课程第一页
		// 2. 将数据拆分到三个数组。推荐内容最多五个。如果五个，则1+4的形式。如果不足五个，偶数则2+n、奇数1+n、不足两个则只放一行一列n个。中间插入视频课程，第一页其余部分放入更多推荐视频里。如果不足五个，则不显示更多推荐视频
		// 3. 如果有第二页则继续放
		this.requestInitialData();
	},
};
</script>
<style scoped>
.list-container {
	/* background: lightblue; */
	padding-bottom: 24px;
}
.top-course-item {
	width: 40%;
	margin: 4px 8px;
}
.section-title {
	font-size: 17px;
	font-weight: bold;
	color: #555;
	margin-bottom: 4px;
}
.section {
	margin-top: 16px;
}
</style>
